import { render, staticRenderFns } from "./page1Mobile.vue?vue&type=template&id=deba4f86&scoped=true&"
import script from "./page1Mobile.vue?vue&type=script&lang=js&"
export * from "./page1Mobile.vue?vue&type=script&lang=js&"
import style0 from "./page1Mobile.vue?vue&type=style&index=0&id=deba4f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deba4f86",
  null
  
)

export default component.exports